import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.esm.browser.min.js'
class RecommendationSection extends HTMLElement {
  constructor() {
    super();
    this.processedGalleries = new Set();
    this.swiperInstances = new Map();
    this.activeSlide = null;
    this.lastGallery = null;
  }

  connectedCallback() {
    this.observeChanges();
    this.setupGlobalTouchEvents();
  }

  setupGlobalTouchEvents() {
    // Add a global touch event to reset active slide when touching outside
    document.addEventListener('touchstart', (e) => {
      // Check if the touch is outside of any slide
      const isOutsideSlide = !e.target.closest('.swiper-slide');
      
      if (isOutsideSlide && this.activeSlide) {
        this.resetSlide(this.activeSlide);
        this.activeSlide.classList.remove('active');
        this.activeSlide = null;
      }
    });
  }


  observeChanges() {
    const observer = new MutationObserver(() => {
      const galleries = this.querySelectorAll('.product-swiper-component .image-grid-gallery-new');
      
      // Check if there are any new galleries to process
      let newGalleriesFound = false;
      galleries.forEach(gallery => {
        if (!this.processedGalleries.has(gallery)) {
          newGalleriesFound = true;
          this.processedGalleries.add(gallery);
        }
      });

      // Only proceed if we found new galleries
      if (newGalleriesFound) {
        this.recommendationSwiper(galleries);
      }
    });

    // Continue observing to catch any new galleries
    observer.observe(this, { childList: true, subtree: true });
  }

  recommendationSwiper(galleries) {
    const isMobile = window.matchMedia("(max-width: 640px)").matches;
    galleries.forEach((gallery) => {
      // Skip if this gallery already has a Swiper instance
      if (gallery.classList.contains('swiper-initialized')) return;
      
      // Create a unique identifier for this gallery if it doesn't exist
      if (!gallery.dataset.galleryId) {
        const randomId = Math.random().toString(36).substring(2, 9);
        gallery.dataset.galleryId = randomId;
        
        // Add a unique class to this specific gallery
        gallery.classList.add(`gallery-${randomId}`);
        
        // Also add unique identifiers to navigation buttons for this gallery
        const nextButton = gallery.querySelector('.swiper-button-next');
        const prevButton = gallery.querySelector('.swiper-button-prev');
        
        if (nextButton) {
          nextButton.classList.add(`next-${randomId}`);
        }
        
        if (prevButton) {
          prevButton.classList.add(`prev-${randomId}`);
        }
      }
      // Destroy existing Swiper instance if it exists
      if (gallery.swiper) {
        gallery.swiper.destroy(true, true);
        gallery.swiper = null; // Clear reference
      }
      
      // Initialize Swiper with gallery-specific navigation selectors
      try {
        const galleryId = gallery.dataset.galleryId;
        gallery.classList.add(`gallery-${galleryId}`);

        const nextButton = gallery.querySelector('.swiper-button-next');
        const prevButton = gallery.querySelector('.swiper-button-prev');

        const swiper = new Swiper(gallery, {
          spaceBetween: 5,
          slidesPerView: 1,
          slidesPerGroup: 1,
          initialSlide: 0,
          loop: true,
          allowTouchMove: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton
          },
          breakpoints: {
            641: {
              allowTouchMove: false,
              slidesPerView: 'auto',
              initialSlide: 1,
            }
          },
        });

        if(isMobile) {

         // hide arrows by default
        const nextBtn = gallery.querySelector('.swiper-button-next');
        const prevBtn = gallery.querySelector('.swiper-button-prev');

        // Show arrows only on first slide change
        let arrowsShown = false;
        function showArrows() {
          if (arrowsShown) return;
          arrowsShown = true;
          [nextBtn, prevBtn].forEach(btn => {
            if (btn) {
              btn.style.opacity = '1';
              btn.style.pointerEvents = 'auto';
            }
          });
        }

        swiper.on('slideChange', showArrows);
      }

        gallery.swiper = swiper;
        this.swiperInstances.set(gallery, swiper);

        if (isMobile) return;

        const mainImage = gallery.querySelector('.swiper-slide.main_image');
        const hoverImage = gallery.querySelector('.swiper-slide.hover_image');
        const FalseImageContainer = gallery.closest('.ProductItem__ImageWrapper');
        const FalseImageHover = FalseImageContainer?.querySelector('.image-for-hover');
        const swiperInstance = gallery.swiper;
        const slides = Array.from(gallery.querySelectorAll('.swiper-slide'));
        const mainIndex = slides.indexOf(mainImage);
        const hoverIndex = slides.indexOf(hoverImage);

        if (!mainImage || !hoverImage || !FalseImageHover) return;

        FalseImageHover.style.opacity = '1';
        FalseImageHover.style.zIndex = '1';

        FalseImageHover.addEventListener('mouseenter', () => {
          FalseImageHover.style.opacity = '0';
          swiperInstance.slideTo(hoverIndex, 0);
          FalseImageHover.style.zIndex = '-1';
        });

        gallery.addEventListener('mouseleave', () => {
          FalseImageHover.style.opacity = '1';
          FalseImageHover.style.zIndex = '1';
        });
      } catch (error) {
        console.error(`Failed to initialize Swiper for gallery ${gallery.dataset.galleryId}:`, error);
      }

    });
  }
}

customElements.define('recommendation-section', RecommendationSection);